import { render, staticRenderFns } from "./ScopeOfPracticeConfig.vue?vue&type=template&id=b0f75356&scoped=true&"
import script from "./ScopeOfPracticeConfig.vue?vue&type=script&lang=js&"
export * from "./ScopeOfPracticeConfig.vue?vue&type=script&lang=js&"
import style0 from "./ScopeOfPracticeConfig.vue?vue&type=style&index=0&id=b0f75356&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f75356",
  null
  
)

export default component.exports